module.exports = __webpack_public_path__ + "img/comp-baituhe.9878ccba.svg";